import * as style from "./List.css";

export const ol = (props: Object) => <ol className={style.ol} {...props} />;

export const oli = (props: Object) => <li className={style.oli} {...props} />;
